import { Uuid } from "@/domains/global/identifiers";
import { MDSRowItemAppearance } from "@/mds";
import { AppStore } from "@/store";

export const resolveItemAppearance = ({
  itemId,
  appStore,
}: {
  itemId: Uuid;
  appStore: AppStore;
}): MDSRowItemAppearance => {
  const noteObservable = appStore.notes.get(itemId);

  if (noteObservable?.suggestionData) {
    return MDSRowItemAppearance.ActiveSuggestion;
  }

  const audioRecordingObservable = appStore.audioRecordings.getNoteRecording({
    noteId: itemId,
  }).recording;

  if (audioRecordingObservable?.associatedNoteId === itemId) {
    // TODO(macromackie): In the future we should surface upload failures in the source chips
    // so users can resolve them directly. For now, we rely on auto-reupload and avoid
    // turning the row red for upload-only failures.
    // if (audioRecordingObservable.hasFailedUploading) {
    //   return MDSRowItemAppearance.AudioRecordingUploadingFailed;
    // }

    if (audioRecordingObservable.hasFailedProcessing) {
      return MDSRowItemAppearance.AudioRecordingProcessingFailed;
    }

    if (audioRecordingObservable.isProcessing) {
      return MDSRowItemAppearance.AudioRecordingProcessing;
    }

    if (audioRecordingObservable.hasFinishedProcessing) {
      return MDSRowItemAppearance.Standard;
    }

    if (audioRecordingObservable.isUploading) {
      return MDSRowItemAppearance.AudioRecordingUploading;
    }

    if (audioRecordingObservable.isRecording) {
      return MDSRowItemAppearance.AudioRecordingRecording;
    }
  }

  return MDSRowItemAppearance.Standard;
};
